import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54603a05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "souvenir_main-container" }
const _hoisted_2 = { class: "body-section" }
const _hoisted_3 = { class: "souvenir-container" }
const _hoisted_4 = { class: "voice-container" }
const _hoisted_5 = ["defaultValue"]
const _hoisted_6 = { class: "souvenir-body" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { class: "input-style" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  disabled: "",
  name: "choice",
  value: "HTML",
  id: "friend"
}, null, -1))
const _hoisted_10 = { class: "radio-label" }
const _hoisted_11 = { class: "input-style" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  disabled: "",
  name: "choice",
  value: "HTML",
  id: "confidential"
}, null, -1))
const _hoisted_13 = { class: "radio-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalSidebar = _resolveComponent("ModalSidebar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Confirm = _resolveComponent("Confirm")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'prevent-submit': $setup.recognizedSpeech.length < 1 })
  }, [
    _createVNode(_component_Confirm, {
      data: $setup.souvenirPopupData,
      maxWidth: "90vw",
      maxHeight: "97vh"
    }, {
      alertBody: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ModalSidebar, {
            title: _ctx.$t('views.souvenir.associateAMemoryWithTitle'),
            tracks: [$props.item]
          }, null, 8, ["title", "tracks"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('views.souvenir.yourMemory')), 1),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["microphone-span_cursor-pointer", { active: $setup.isMicOn }]),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleMic && $setup.toggleMic(...args)))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "mic-icon",
                    icon: "fa-solid fa-microphone"
                  })
                ], 2), [
                  [_vShow, $setup.hasSpeechRecognition]
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  defaultValue: $setup.recognizedSpeech,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.recognizedSpeech) = $event))
                }, null, 8, _hoisted_5), [
                  [_vModelText, $setup.recognizedSpeech]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('views.souvenir.typeOfMemory')), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('views.souvenir.accessibleToFriendsAndFamily')) + "*", 1)
                  ]),
                  _createElementVNode("label", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('generic.confidential')), 1)
                  ])
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.souvenir.accessibleToFriendsAndFamilyAgreed')), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["data"])
  ], 2))
}